<!-- <div class="upload-template-comp"> -->
<div fxLayout="row" fxLayoutAlign="end center">
  <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
</div>
<div fxLayout="column" fxLayoutAlign="center center">
  <label mat-dialog-title class="otpHeader">Upload image</label>
  <p>You can adjust profile icon of your business</p>
</div>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">

  <div fxLayout="column" fxLayoutAlign="center center" class="upload-template-box-out">

    <ly-img-cropper [withClass]="classes.cropper" [config]="myConfig" [(scale)]="scale" (minScale)="minScale = $event"
      (ready)="ready = true" (cleaned)="ready = false" (cropped)="onCropped($event)" (loaded)="onLoaded($event)"
      (error)="onError($event)">

    </ly-img-cropper>
  </div>
  <div class="grid-container">
    <div class="grid-item" style="transform: scale(0.7); color:#999999">
      <mat-icon>photo</mat-icon>
    </div>
    <div class="grid-item" *ngIf="ready">
      <ly-slider style="width: 240px;" [thumbVisible]="false" [min]="minScale" [max]="1" [(ngModel)]="scale" (input)="onSliderInput($event)"
        [step]="0.000001" [color]="'primary'"></ly-slider>
    </div>
    <div class="grid-item" style="color:#999999">
      <mat-icon>photo</mat-icon>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" style="width:100%">
    <button type="button" class="verify-btn" fxFlex="33" fxLayoutAlign="center center" style="padding:10px 0;"
      (click)="closePopup()">Cancel <mat-icon>
        chevron_right
      </mat-icon>
    </button>
    <button class="verify-btn" fxLayoutAlign="center center" fxFlex="30"
      style="padding:10px 0;background: #386AF6; color:#fff;font-family: 'Montserrat';font-style: normal;font-size: 14px; "
      (click)="cropper.crop()">
      Save
      <mat-icon>
        chevron_right
      </mat-icon>
    </button>
  </div>
</div>